import { render } from "./ProjectDetailsUnit.vue?vue&type=template&id=f125a7e4&scoped=true"
import script from "./ProjectDetailsUnit.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsUnit.vue?vue&type=script&lang=js"

import "./ProjectDetailsUnit.vue?vue&type=style&index=0&id=f125a7e4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f125a7e4"]])

export default __exports__